import { render } from "./EvvDetailsHomeCare.vue?vue&type=template&id=4820ec9d&scoped=true"
import script from "./EvvDetailsHomeCare.ts?vue&type=script&lang=js&external"
export * from "./EvvDetailsHomeCare.ts?vue&type=script&lang=js&external"

import "./EvvDetailsHomeCare.vue?vue&type=style&index=0&id=4820ec9d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4820ec9d"]])

export default __exports__